import styled from 'styled-components';

export const StyledContractObligationPage = styled.div`
  height: 100%;
  overflow: auto;
`;
